import {
	MimaButton,
	MimaText,
	Modal,
	MimaDropdown,
	PageLoader,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { amountFormatter } from '../../utils/utils';
import { Formik } from 'formik';
import moment from 'moment';
import React from 'react';

const PayrollSummary = ({
	closeModal,
	months,
	schemaValidation,
	years,
	loading,
	statuses,
	departments,
	onSubmit,
	payrollSummary,
	employeeGroups,
	stage2,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<div className={styles.ps}>
				{!stage2 && (
					<>
						<MimaText variant="subtitle" align="center" mb={2}>
							Payroll Summary
						</MimaText>
						<Formik
							initialValues={{
								employeeGroup: '',
								employeeGroupName: '',
								departmentName: '',
								department: '',
								status: '',
								month: '',
								year: '',
							}}
							validationSchema={schemaValidation}
							onSubmit={onSubmit}>
							{({ handleSubmit, setFieldValue, values, errors, touched }) => (
								<>
									<MimaDropdown
										labelTitle="Year"
										placeholder="Select"
										name="year"
										value={values.year}
										id="year"
										onChange={data => {
											setFieldValue('year', data.key);
										}}
										data={years}
										touched={touched.year}
										error={errors.year}
									/>
									<MimaDropdown
										labelTitle="Month"
										placeholder="Select"
										name="month"
										value={values.month}
										id="month"
										onChange={data => {
											setFieldValue('month', data.key);
										}}
										data={months}
										touched={touched.month}
										error={errors.month}
									/>

									<MimaDropdown
										labelTitle="Department(optional)"
										placeholder="Select"
										canSelectAll={true}
										name="department"
										value={values.departmentName}
										id="department"
										onChange={data => {
											setFieldValue('department', data.key);
											setFieldValue('departmentName', data.value);
										}}
										data={departments}
										touched={touched.department}
									/>
									{/* <MimaDropdown
										labelTitle="Select Employee Group(optional)"
										placeholder="Select"
										name="employeeGroup"
										canSelectAll={true}
										value={values.employeeGroupName}
										id="employeeGroup"
										onChange={data => {
											setFieldValue('employeeGroup', data.key);
											setFieldValue('employeeGroupName', data.value);
										}}
										data={employeeGroups}
									/> */}

									<MimaDropdown
										labelTitle="Status(optional)"
										canSelectAll={true}
										placeholder="Select"
										name="status"
										value={values.status}
										id="status"
										onChange={data => {
											setFieldValue('status', data.key);
										}}
										data={statuses}
										touched={touched.status}
									/>
									<MimaButton
										title="Search"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										mt={2}
									/>
								</>
							)}
						</Formik>
					</>
				)}

				{stage2 && (
					<>
						{loading ? (
							<PageLoader
								title="while your summary is generated"
								loading={loading}
							/>
						) : (
							<>
								{Object.keys(payrollSummary).length !== 0 ? (
									<>
										<MimaText mt={4} mb={2} variant="smallBold" align="center">
											Payroll Summary for{' '}
											{moment(payrollSummary.payDay).format('MMMM')}
										</MimaText>
										<MimaText labelTitle="Your Total Payroll Net cost" mb={2}>
											{amountFormatter().format(payrollSummary.totalNet)}
										</MimaText>
										<MimaText labelTitle="Pay Day" mb={2}>
											{moment(payrollSummary.payDay).format('Do MMMM, YYYY')}
										</MimaText>
										<MimaText labelTitle="Number of Employees" mb={2}>
											{`Total Employees ${payrollSummary.totalEmployees}`}
										</MimaText>
										<div className={styles.ps__breakdown}>
											<table>
												<thead>
													<tr className={styles.ps__breakdown_bdr}>
														<th>Breakdown</th>
														<th>Amount</th>
													</tr>
												</thead>
												<tbody>
													<tr className={styles.ps__breakdown_bdr}>
														<td>Initial Salary Gross</td>
														<td>
															{amountFormatter().format(
																payrollSummary.totalInitialGrossPay
															)}
														</td>
													</tr>
													<tr className={styles.ps__breakdown_sm}>
														<td>PAYE Tax</td>
														<td>
															-
															{amountFormatter().format(
																payrollSummary.totalTax
															)}
														</td>
													</tr>
													<tr className={styles.ps__breakdown_sm}>
														<td>WHT</td>
														<td>
															-
															{amountFormatter().format(
																payrollSummary.totalWHT
															)}
														</td>
													</tr>
													<tr
														className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
														<td>Pension</td>
														<td>
															-
															{amountFormatter().format(
																payrollSummary.totalPension
															)}
														</td>
													</tr>
													<tr
														className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
														<td>NHF</td>
														<td>
															-
															{amountFormatter().format(
																payrollSummary.totalNHF
															)}
														</td>
													</tr>
													{payrollSummary?.deductions?.map(deduction => (
														<tr className={styles.ps__breakdown_sm}>
															<td>{deduction.type}</td>
															<td>
																-{amountFormatter().format(deduction.amount)}
															</td>
														</tr>
													))}
													<tr
														className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
														<td>Other Deductions</td>
														<td>
															-
															{amountFormatter().format(
																payrollSummary.totalOtherDeductions
															)}
														</td>
													</tr>
													{payrollSummary?.additions?.map(sum => (
														<tr className={styles.ps__breakdown_sm}>
															<td>{sum.type}</td>
															<td>{amountFormatter().format(sum.amount)}</td>
														</tr>
													))}
													<tr>
														<td> Total Additions</td>
														<td>
															{amountFormatter().format(
																payrollSummary.extraAddition
															)}
														</td>
													</tr>
													<tr>
														<th>Total</th>
														<th>
															{amountFormatter().format(
																payrollSummary.totalNet
															)}
														</th>
													</tr>
												</tbody>
											</table>
										</div>
									</>
								) : (
									<MimaText mb={2} width={38} align="center">
										No Record Found
									</MimaText>
								)}
							</>
						)}
					</>
				)}
			</div>
		</Modal>
	);
};

export default PayrollSummary;
